import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgGoogleSingle() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      d: "M5.876 14.295l-.766 2.859-2.8.059A10.95 10.95 0 011 12c0-1.824.444-3.544 1.23-5.059l2.492.457 1.092 2.477A6.54 6.54 0 005.461 12c0 .807.146 1.581.415 2.295zM22.808 9.945a11.023 11.023 0 01-.048 4.352 10.997 10.997 0 01-3.873 6.281h-.001l-3.139-.16-.444-2.773a6.556 6.556 0 002.82-3.348h-5.881V9.945H22.808z",
      fill: "currentColor"
    }, void 0), _jsx("path", {
      d: "M18.886 20.578A10.953 10.953 0 0112 23c-4.19 0-7.831-2.341-9.69-5.787l3.566-2.918a6.54 6.54 0 009.427 3.35l3.583 2.933zM19.021 3.532L15.458 6.45a6.542 6.542 0 00-9.644 3.425L2.231 6.94H2.23A10.998 10.998 0 0112 1c2.669 0 5.116.95 7.021 2.532z",
      fill: "currentColor"
    }, void 0)]
  }), void 0);
}

export default SvgGoogleSingle;